import React, { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import { toast } from "react-toastify";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { useLocation, useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { Spinner } from "reactstrap";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import ViewDocumentModal from "../ViewDocumentModal";
import ConfirmModal from "../../../components/comman/ConfirmModal";
import { errorTypes } from "../../../utility/InputValidation";

export default function AddCompany() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    reset,
    control,
  } = useForm({
    defaultValues: {
      content: "",
    },
  });
  const location = useLocation();
  console.log("location====>", location?.state?.EditData);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingBankData, setIsLoadingBankData] = useState(false);
  const [existingDocuments, setExistingDocuments] = useState([]);
  const [newDocuments, setNewDocuments] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const toggleConfirmModal = () => setConfirmModal(!confirmModal);
  const [selectedId, setSelectedId] = useState("");
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };

  const fetchBankDetails = async (ifsc) => {
    if (ifsc && ifsc.length === 11) {
      setIsLoadingBankData(true);
      try {
        const response = await fetch(`https://ifsc.razorpay.com/${ifsc}`);
        if (response.ok) {
          const data = await response.json();
          setValue("bankName", data.BANK || "");
          setValue("branchName", data.BRANCH || "");
        } else {
          toast.error("Invalid IFSC Code");
        }
      } catch (error) {
        console.error("Error fetching bank details:", error);
      } finally {
        setIsLoadingBankData(false);
      }
    } else {
      setIsLoadingBankData(false);
    }
  };

  // console.log("newDocuments======>", newDocuments);
  useEffect(() => {
    if (location?.state?.EditData) {
      reset({
        name: location?.state?.EditData?.name,
        shortName: location?.state?.EditData?.shortName,
        email: location?.state?.EditData?.email,
        phone: location?.state?.EditData?.phone,
        secondaryEmail: location?.state?.EditData?.secondaryEmail,
        secondaryPhone: location?.state?.EditData?.secondaryPhone,
        gst: location?.state?.EditData?.gst,
        content: location?.state?.EditData?.tANDc,
        address: location?.state?.EditData?.address,
        pinCode: location?.state?.EditData?.pinCode,
        state: location?.state?.EditData?.state,
        panNumber: location?.state?.EditData?.pan,
        city: location?.state?.EditData?.city,
        accountHolder: location?.state?.EditData?.accountHolder,
        accountNumber: location?.state?.EditData?.accountNumber,
        ifscCode: location?.state?.EditData?.IFSC_code,
        bankName: location?.state?.EditData?.bankName,
        branchName: location?.state?.EditData?.branchName,
      });
      setExistingDocuments(location.state?.EditData?.documents);
    } else {
      reset();
    }
  }, []);

  const checkRequiredDocuments = () => {
    const requiredDocs = [
      "Company_Logo",
      "GST_Registration_Document",
      "Company_Registration_Document",
    ];

    for (let docType of requiredDocs) {
      const existsInNew = newDocuments.some(
        (doc) => doc.hasOwnProperty(docType) && doc[docType] !== null
      );
      const existsInExisting = existingDocuments.some(
        (doc) => doc.name === docType && doc.url // Assuming each `existingDocument` has `name` and `url`
      );

      if (!existsInNew && !existsInExisting) {
        setError(`${docType.replaceAll("_", " ")} is required`);
        return false;
      }
    }

    setError(""); // Clear error if all docs are present
    return true;
  };

  const onSubmit = (data) => {

    if (!checkRequiredDocuments()) {
      toast.error("All Three Documents are Required")
      return;
    }
    const postData = {
      name: data?.name,
      shortName: data?.shortName,
      email: data?.email,
      secondaryEmail: data?.secondaryEmail,
      phone: data?.phone,
      secondaryPhone: data?.secondaryPhone,
      gst: data?.gst,
      tANDc: data?.content,
      address: data?.address,
      city: data?.city,
      state: data?.state,
      pan: data?.panNumber,
      pinCode: data?.pinCode,
      accountHolder: data?.accountHolder,
      accountNumber: data?.accountNumber,
      IFSC_code: data?.ifscCode,
      bankName: data?.bankName,
      branchName: data?.branchName,
    };

    // console.log("newDocuments======>",newDocuments);

    const formData = new FormData();
    Object.keys(postData).forEach((key) => {
      const value = postData[key];
      if (value) {
        // Check if the value exists before appending
        formData.append(key, value);
      }
    });

    newDocuments.forEach((doc) => {
      const [key, file] = Object.entries(doc)[0];
      if (file) {
        formData.append(key, file);
      }
    });

    const option = {
      method: "POST",
      form_data: formData,
    };

    // console.log(postData);

    setIsLoading(true);
    // const endPoint = "testing-uploading-file";
    const endPoint = location?.state?.EditData
      ? apiUrl.add_company + `?companyId=${location?.state?.EditData?.id}`
      : apiUrl.add_company;
    // Call the API
    callApi(endPoint, option)
      .then((res) => {
        if (res?.status === true) {
          toast.success(res?.message);
          navigate(-1);
          reset();
        } else {
          toast.error(res?.message);
        }
      })
      .catch(() => {
        toast.error("An error occurred");
      })
      .finally(() => setIsLoading(false));
  };

  // Add new document
  const addDocument = () => {
    const selectedDocument = watch("documentType");
    if (
      selectedDocument &&
      !newDocuments.some((doc) => doc[selectedDocument]) &&
      !existingDocuments.some((doc) => doc.name === selectedDocument)
    ) {
      setNewDocuments((prev) => [...prev, { [selectedDocument]: null }]);
      setValue("documentType", ""); // Reset dropdown
    }
  };

  const handleFileChange = (key, file, event) => {
    if (file && file.size > 6 * 1024 * 1024) {
      toast.error("File size must be less than 6MB");
      if (event) event.target.value = "";
      return;
    }
    setNewDocuments((prev) =>
      prev.map((doc) => (doc[key] !== undefined ? { [key]: file } : doc))
    );
    if (key === "Company_Logo") {
      setError("");
    }
  };

  const handleDocumentClick = (item) => {
    // console.log("item---->", item);
    const docUrl = {
      url: item?.url,
    };
    setSelectedDocument(docUrl);
    setModal(true);
  };

  const removeNewDocument = (key) => {
    setNewDocuments((prev) => prev.filter((doc) => !doc.hasOwnProperty(key)));
  };

  // Delete an existing document via API
  const handleDeleteDocument = () => {
    const API = `${apiUrl.delete_document}?documentId=${selectedId}`;
    callApi(API, { method: "GET" }).then((response) => {
      toggleConfirmModal();
      if (response?.status === true) {
        setExistingDocuments((prev) =>
          prev.filter((doc) => doc.id !== selectedId)
        );
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };

  const ActionHandler = (id) => {
    setSelectedId(id);
    toggleConfirmModal();
  };

  return (
    <>
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button className="btn back-arrow" onClick={() => navigate(-1)}>
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">
              {location?.state?.EditData ? "Edit" : "Add"} Company
            </h1>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="row">
                  <div className="col-12">
                    <h4 className="fs-3 rajdhani-semibold my-4 border-bottom pb-3">
                      Company Details
                    </h4>
                  </div>
                  <div className="col-12 col-md-6 col-lg-6">
                    <div className="form-group mb-3">
                      <label
                        htmlFor="totalLeavePerMonth"
                        className="form-label"
                      >
                        Name
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="totalLeavePerMonth"
                        className="form-control"
                        placeholder="Enter name of company"
                        {...register("name", {
                          ...errorTypes.required("Company Name"),
                        })}
                      />
                      <ErrorMessage message={errors?.name?.message} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-6">
                    <div className="form-group mb-3">
                      <label
                        htmlFor="totalLeavePerMonth"
                        className="form-label"
                      >
                        Short Name
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="totalLeavePerMonth"
                        className="form-control"
                        placeholder="Enter short name of company"
                        {...register("shortName", {
                          ...errorTypes.required("Company shortName"),
                        })}
                      />
                      <ErrorMessage message={errors?.shortName?.message} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-6">
                    <div className="form-group mb-3">
                      <label
                        htmlFor="totalLeavePerMonth"
                        className="form-label"
                      >
                        Email
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="totalLeavePerMonth"
                        className="form-control"
                        placeholder="Enter email of company"
                        {...register("email", {
                          ...errorTypes.required("Email"),
                          ...errorTypes.email,
                          onChange: (e) => {
                            const lowercaseValue = e.target.value.toLowerCase();
                            setValue("email", lowercaseValue);
                          },
                        })}
                      />
                      <ErrorMessage message={errors?.email?.message} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-6">
                    <div className="form-group mb-3">
                      <label htmlFor="secondaryEmail" className="form-label">
                        Secondary Email
                      </label>
                      <input
                        type="text"
                        id="secondaryEmail"
                        className="form-control"
                        placeholder="Enter email of company"
                        {...register("secondaryEmail", {
                          ...errorTypes.email,
                          onChange: (e) => {
                            const lowercaseValue = e.target.value.toLowerCase();
                            setValue("secondaryEmail", lowercaseValue);
                          },
                        })}
                      />
                      <ErrorMessage message={errors?.secondaryEmail?.message} />
                    </div>
                  </div>

                  <div className="col-12 col-md-6 col-lg-6">
                    <div className="form-group mb-3">
                      <label
                        htmlFor="totalLeavePerMonth"
                        className="form-label"
                      >
                        Contact No.
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="totalLeavePerMonth"
                        className="form-control"
                        placeholder="Enter contact number"
                        {...register("phone", {
                          ...errorTypes.required("Company Contact Number"),
                          ...errorTypes.phone
                        })}
                        onChange={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                        }}
                      />
                      <ErrorMessage message={errors?.phone?.message} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-6">
                    <div className="form-group mb-3">
                      <label
                        htmlFor="totalLeavePerMonth"
                        className="form-label"
                      >
                        Secondary Contact No.
                      </label>
                      <input
                        type="text"
                        id="totalLeavePerMonth"
                        className="form-control"
                        placeholder="Enter contact number"
                        {...register("secondaryPhone", {
                          ...errorTypes.phone
                        })}
                        onChange={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                        }}
                      />
                      <ErrorMessage message={errors?.secondaryPhone?.message} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-6">
                    <div className="form-group mb-3">
                      <label
                        htmlFor="totalLeavePerMonth"
                        className="form-label"
                      >
                        GST Number
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="totalLeavePerMonth"
                        className="form-control"
                        placeholder="Enter GST number of company"
                        {...register("gst", {
                          ...errorTypes.required("Company GST"),
                        })}
                      />
                      <ErrorMessage message={errors?.gst?.message} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-6">
                    <div className="form-group mb-3">
                      <label htmlFor="panNum" className="form-label">
                        PAN Number
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="PAN Number"
                        id="panNum"
                        {...register("panNumber", {
                          ...errorTypes.required("Company Pan Card"),
                          ...errorTypes.pan
                        })}
                        onChange={(e) => {
                          e.target.value = e.target.value.toUpperCase();
                        }}
                      />
                      <ErrorMessage message={errors?.panNumber?.message} />
                    </div>
                  </div>

                  <div className="col-12 col-md-6 col-lg-6">
                    <div className="form-group mb-3">
                      <label
                        htmlFor="totalLeavePerMonth"
                        className="form-label"
                      >
                        Address
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="totalLeavePerMonth"
                        className="form-control"
                        placeholder="Enter your address.."
                        {...register("address", {
                          ...errorTypes.required("Address"),
                        })}
                      />
                      <ErrorMessage message={errors?.address?.message} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-6">
                    <div className="form-group mb-3">
                      <label
                        htmlFor="totalLeavePerMonth"
                        className="form-label"
                      >
                        State
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="totalLeavePerMonth"
                        className="form-control"
                        placeholder="Enter your State.."
                        {...register("state", {
                          ...errorTypes.required("State"),
                        })}
                      />
                      <ErrorMessage message={errors?.state?.message} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-6">
                    <div className="form-group mb-3">
                      <label
                        htmlFor="totalLeavePerMonth"
                        className="form-label"
                      >
                        City
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="totalLeavePerMonth"
                        className="form-control"
                        placeholder="Enter your City.."
                        {...register("city", {
                          ...errorTypes.required("City"),
                        })}
                      />
                      <ErrorMessage message={errors?.city?.message} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-6">
                    <div className="form-group mb-3">
                      <label
                        htmlFor="totalLeavePerMonth"
                        className="form-label"
                      >
                        Zip Code
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="totalLeavePerMonth"
                        className="form-control"
                        placeholder="Enter your Zip Code.."
                        {...register("pinCode", {
                          ...errorTypes.required("Zip Code"),
                          ...errorTypes.pincode("Zip Code")
                        })}
                        onChange={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                        }}
                      />
                      <ErrorMessage message={errors?.pinCode?.message} />
                    </div>
                  </div>



                  <div className="row border border-light rounded-4 my-3 p-4">
                    <div className="col-12">
                      <h4 className="fs-3 rajdhani-semibold my-4 border-bottom pb-3">Bank Details</h4>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6">
                      <div className="form-group mb-3">
                        <label
                          htmlFor="accountHolder"
                          className="form-label"
                        >
                          Account Holder Name
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Account holder name.."
                          {...register("accountHolder", {
                            ...errorTypes.required("Account Holder Name"),
                          })}
                          onChange={(e) => {
                            e.target.value = e.target.value.replace(
                              /[^a-zA-Z ]/g,
                              ""
                            );
                          }}
                        />
                        <ErrorMessage message={errors?.accountHolder?.message} />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6">
                      <div className="form-group mb-3">
                        <label
                          htmlFor="accountNumber"
                          className="form-label"
                        >
                          Account Number
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Account number.."
                          {...register("accountNumber", {
                            ...errorTypes.required("Account Number"),
                          })}
                          onChange={(e) => {
                            e.target.value = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            );
                          }}
                        />
                        <ErrorMessage message={errors?.accountNumber?.message} />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label
                          htmlFor="ifscCode"
                          className="form-label"
                        >
                          IFSC Code
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter IFSC Code.."
                          maxLength={11}
                          {...register("ifscCode", {
                            ...errorTypes.required("IFSC Code"),
                            pattern: {
                              value: /^[A-Z0-9]*$/,
                              message: "It must contain only numbers and letters",
                            },
                            onChange: (e) => {
                              e.target.value = e.target.value.toUpperCase();
                              if (e.target.value.length === 11) {
                                fetchBankDetails(e.target.value);
                              } else {
                                setValue("bankName", "");
                                setValue("branchName", "");
                              }
                            }
                          })}
                        />
                        <ErrorMessage message={errors?.ifscCode?.message} />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label
                          htmlFor="bankName"
                          className="form-label"
                        >
                          Bank Name
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Bank Name.."
                          {...register("bankName", {
                            ...errorTypes.required("Bank Name"),
                          })}
                          disabled={isLoadingBankData || true}
                        />
                        <ErrorMessage message={errors?.bankName?.message} />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label
                          htmlFor="branchName"
                          className="form-label"
                        >
                          Branch Name
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Branch Name.."
                          {...register("branchName", {
                            ...errorTypes.required("Branch Name"),
                          })}
                          disabled={isLoadingBankData || true}
                        />
                        <ErrorMessage message={errors?.branchName?.message} />
                      </div>
                    </div>
                  </div>




                  <div className="col-12 ">
                    <div className="form-group mb-3">
                      <label
                        htmlFor="totalLeavePerMonth"
                        className="form-label"
                      >
                        Terms & Conditions
                        <span className="text-danger">*</span>
                      </label>
                      <Controller
                        name="content"
                        control={control}
                        rules={{
                          required: "Terms & Conditions are required", // Field is required
                        }}
                        render={({ field }) => (
                          <div>
                            <CKEditor
                              {...field}
                              editor={ClassicEditor}
                              data={field.value || ""}
                              onChange={(event, editor) => {
                                field.onChange(editor.getData()); // Update form state on change
                              }}
                              config={{
                                toolbar: [
                                  "heading",
                                  "|",
                                  "bold",
                                  "italic",
                                  "underline",
                                  "strikethrough",
                                  "|",
                                  "fontColor",
                                  "fontBackgroundColor",
                                  "fontFamily",
                                  "fontSize",
                                  "alignment",
                                  "|",
                                  "link",
                                  "bulletedList",
                                  "numberedList",
                                  "blockQuote",
                                  "undo",
                                  "redo",
                                ],
                                image: {
                                  toolbar: [
                                    "imageStyle:alignLeft",
                                    "imageStyle:alignCenter",
                                    "imageStyle:alignRight",
                                    "|",
                                    "imageTextAlternative",
                                  ],
                                },
                                height: "500px", // custom height for CKEditor
                              }}
                            />
                            <ErrorMessage message={errors?.content?.message} />
                          </div>
                        )}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <h4 className="fs-3 rajdhani-semibold my-4 border-bottom pb-3">
                        Documents
                        <span className="text-danger">*</span>
                      </h4>
                    </div>

                    {/* {/ Document Selector /} */}
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label htmlFor="documentType" className="form-label">
                          Select Documents
                        </label>
                        <select
                          className="form-select form-control"
                          {...register("documentType")}
                        >
                          <option value="" className="d-none">
                            Select Documents
                          </option>
                          {[
                            "Company_Registration_Document",
                            "GST_Registration_Document",
                            "Company_Logo",
                          ].map((doc) => (
                            <option
                              key={doc}
                              value={doc}
                              disabled={
                                newDocuments.some((d) => d[doc]) ||
                                existingDocuments.some((d) => d.name === doc)
                              }
                            >
                              {doc.replace(/_/g, " ")}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-4 align-self-end">
                      <div className="form-group mb-3">
                        <button
                          className="btn btn-outline-primary px-4"
                          type="button"
                          onClick={addDocument}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                  {/* {/ Existing Documents /} */}
                  <div className="row">
                    {existingDocuments?.map((doc) => (
                      <div
                        key={doc.id}
                        className="col-12 col-md-6 col-lg-4 mt-3 mb-5 d-flex justify-content-between align-items-center"
                      >
                        <h4
                          className="mb-3"
                          role="button"
                          title="View Document"
                          onClick={() => handleDocumentClick(doc)}
                        >
                          {doc.name.replace(/_/g, " ")}
                        </h4>
                        <button
                          type="button"
                          className="btn btn-sm btn-danger"
                          onClick={() => ActionHandler(doc.id)}
                        >
                          Delete
                        </button>
                      </div>
                    ))}
                  </div>
                  {/* {/ New Documents /} */}
                  <div className="row">
                    {newDocuments.map((doc, index) => {
                      const key = Object.keys(doc)[0];
                      return (
                        <div
                          key={index}
                          className="col-12 col-md-6 col-lg-4 mb-3 "
                        >
                          <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
                            <h4 className="mb-3 ">{key.replace(/_/g, " ")}</h4>
                            <button
                              type="button"
                              className="btn btn-sm btn-danger"
                              onClick={() => removeNewDocument(key)}
                            >
                              Remove
                            </button>
                          </div>
                          <div className="img-uploader">
                            <input
                              type="file"
                              accept={
                                key === "Company_Logo" ? "image/*" : ".pdf"
                              }
                              className="form-control"
                              onChange={(e) =>
                                handleFileChange(key, e.target.files[0], e)
                              }
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <ErrorMessage message={error} />

                <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-3">
                  <button
                    className="btn btn-secondary px-5"
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary px-5">
                    {isLoading ? (
                      <Spinner />
                    ) : location?.state?.EditData ? (
                      "Edit Company"
                    ) : (
                      "Add Company"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
      <ConfirmModal
        modal={confirmModal}
        toggle={toggleConfirmModal}
        submitHandler={handleDeleteDocument}
        isLoading={isLoading}
      />
    </>
  );
}
